<template>
  <post-count :filters="{ ...filters, mediaTypes: ['image']}" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import PostCount from './PostCount.vue';

export default defineComponent({
  components: { PostCount },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
});
</script>
